import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "message-contents-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrIcon = _resolveComponent("NrIcon")!
  const _component_NrDatepicker = _resolveComponent("NrDatepicker")!
  const _component_NrFormLabel = _resolveComponent("NrFormLabel")!
  const _component_nr_editor = _resolveComponent("nr-editor")!
  const _component_message_box = _resolveComponent("message-box")!

  return (_ctx.displayCreateTaskMsgBox.display)
    ? (_openBlock(), _createBlock(_component_message_box, {
        key: 0,
        title: 
      _ctx.displayCreateTaskMsgBox.type === 'edit' ? 'Edit task' : 'Create task'
    ,
        type: "default",
        "submit-text": 
      _ctx.displayCreateTaskMsgBox.type === 'edit' ? 'Update task' : 'Create task'
    ,
        "disable-submit": $options.disableTaskSubmitBtn,
        onOnClose: $options.handleCloseTask,
        onOnSubmit: $options.handleSubmitTask,
        onOnCancel: $options.handleCancelMessage
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_NrSelect, {
              placeholder: "Select a user to assign task",
              modelValue: $data.selectedCreateTaskAssignee,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedCreateTaskAssignee) = $event)),
              options: $options.requestStaffList
            }, {
              label: _withCtx(() => [
                _createTextVNode(" User ")
              ]),
              _: 1
            }, 8, ["modelValue", "options"]),
            _createVNode(_component_NrDatepicker, {
              modelValue: $data.taskDueDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.taskDueDate) = $event)),
              calendarStyles: { position: 'absolute', zIndex: 1 }
            }, {
              label: _withCtx(() => [
                _createTextVNode("Due date")
              ]),
              trigger: _withCtx(() => [
                _createVNode(_component_NrIcon, { name: "calendar-alt" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_NrFormLabel, null, {
              default: _withCtx(() => [
                _createTextVNode("Message contents")
              ]),
              _: 1
            }),
            _createVNode(_component_nr_editor, {
              modelValue: $data.taskMsg,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.taskMsg) = $event)),
              resizable: false,
              rows: 12,
              strike: "",
              orderedList: "",
              bulletList: "",
              link: "",
              placeholder: "Enter your task description here"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["title", "submit-text", "disable-submit", "onOnClose", "onOnSubmit", "onOnCancel"]))
    : _createCommentVNode("", true)
}